<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>Input that opens a list of suggestions based on what we type, and we can either select one of the options or type a
  free text.</p>

<!--Joel Test-->
<div class="row" *ngIf="false">
  <jb-input class="col-3" [(ngModel)]="myVar" jbLabel="Normal Input"></jb-input>
  <div class="col-3">
    <jb-autocomplete [(ngModel)]="myVar"
                     [jbList]="myTestOptions1"
                     jbLabel="This is a test">
    </jb-autocomplete>
  </div>
  <jb-input class="col-3" [(ngModel)]="myVar" jbLabel="Normal Input"></jb-input>
  <div class="col-3">myVar={{myVar}} </div>
</div>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12">
  <pre>{{api}}</pre>
</div>

<!--jb-autocomplete Customization-->
<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB25">jb-autocomplete Customization:</h5>
      <div>
        <jb-autocomplete class="full-width"
                         [(ngModel)]="stringSelected"
                         [jbList]="stringList"
                         [jbRequired]="compConf.isRequired"
                         [jbDisabled]="compConf.isDisabled"
                         [jbLabel]="(compConf.hasLabel ? compConf.labelText : '')"
                         [jbPlaceholder]="(compConf.hasPlaceholder ? compConf.placeholderText : '')"
                         [jbTooltip]="(compConf.hasLabel && compConf.hasTooltip ? compConf.tooltipText : null)"
                         [jbTooltipPos]="(compConf.hasLabel && compConf.tooltipPos || 'top')"
                         [jbTooltipBody]="compConf.hasLabel && compConf.tooltipBody"
                         [jbValidType]="compConf.validType"
                         [jbMinLength]="compConf.hasMinLength ? compConf.minLength : null"
        >
        </jb-autocomplete>
        <span style="margin-bottom: 5px;">ngModel: <jb-input [(ngModel)]="stringSelected"></jb-input></span>
      </div>
      <div>
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>
    </div>

    <div class="col-7">

      <div class="row marT15">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.isRequired" (ngModelChange)="upComp()" jbLabel="Is Required"></jb-checkbox>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.isDisabled" (ngModelChange)="upComp()" jbLabel="Is Disabled"></jb-checkbox>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.hasLabel" (ngModelChange)="upComp()" jbLabel="Has Label"></jb-checkbox>
        </div>
        <div class="col-10">
          <jb-input [(ngModel)]="compConf.labelText" (ngModelChange)="upComp()"
                    [jbDisabled]="!compConf.hasLabel"></jb-input>
        </div>
      </div>

      <div class="row marT10">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.hasTooltip" (ngModelChange)="upComp()" jbLabel="Has Tooltip" [jbDisabled]="!compConf.hasLabel"></jb-checkbox>
        </div>
        <div class="col-10" *ngIf="compConf.hasTooltip">
          <jb-input [(ngModel)]="compConf.tooltipText" (ngModelChange)="upComp()"></jb-input>
        </div>
        <div class="col-2" *ngIf="compConf.hasTooltip"></div>
        <div class="col-5" *ngIf="compConf.hasTooltip">
          jbTooltipPos:
          <jb-dropdown [(ngModel)]="compConf.tooltipPos" (ngModelChange)="upComp()"
                       [jbList]="[{ id: 'top', text: 'top' }, { id: 'right', text: 'right' }, { id: 'bottom', text: 'bottom' }, { id: 'left', text: 'left' }]"
                       jbRender="text" jbSelect="id"></jb-dropdown>
        </div>
        <div class="col-5" *ngIf="compConf.hasTooltip">
          jbTooltipBody:
          <jb-dropdown [(ngModel)]="compConf.tooltipBody" (ngModelChange)="upComp()"
                       [jbList]="[{ id: 'true', text: 'true' }, { id: 'false', text: 'false' }]" jbRender="text"
                       jbSelect="id"></jb-dropdown>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.hasPlaceholder" (ngModelChange)="upComp()"
                       jbLabel="Has Placeholder"></jb-checkbox>
        </div>
        <div class="col-10">
          <jb-input [(ngModel)]="compConf.placeholderText" (ngModelChange)="upComp()"
                    [jbDisabled]="!compConf.hasPlaceholder"></jb-input>
        </div>
      </div>

      <div class="row  marT10">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.hasMinLength" (ngModelChange)="upComp()"
                       jbLabel="jbMinLength"></jb-checkbox>
        </div>
        <div class="col-10">
          <jb-input [(ngModel)]="compConf.minLength" (ngModelChange)="upComp()" jbType="number"
                    [jbDisabled]="!compConf.hasMinLength"></jb-input>
        </div>
      </div>

      <div class="row  marT10">
        <div class="col-2 padT5">
          <span class="marL30">jbValidType:</span>
        </div>
        <div class="col">
          <jb-dropdown [(ngModel)]="compConf.validType" [jbList]="validTypes" jbRender="text" jbSelect="id"
                       (ngModelChange)="upComp()"></jb-dropdown>
        </div>
      </div>

    </div>

  </div>
</div>

<hr>

<h5 class="mt-4">Invite Attendee Video Conference case:</h5>
<div class="col-12 examples-table">
  <!-- Normal email insertion -->
  <div class="row">
    <div class="col-4">

      <div class="d-flex flex-column">
        <!-- FORM -->
        <div class="d-flex flex-row justify-content-around">
          <jb-autocomplete #emailAutocomplete
                           #emailAutocompleteRef="ngModel"
                           [(ngModel)]="selection"
                           [jbList]="emailList"
                           jbValidType="email"
                           jbPlaceholder="Select/Type email"
                           (jbSelect)="submit(selection, emailAutocompleteRef.invalid)"
          ></jb-autocomplete>

          <jb-btn jbText="submit" jbType="secondary"
                  [jbDisabled]="emailAutocompleteRef.invalid || !selection"
                  (jbClick)="submit(selection, emailAutocompleteRef.invalid)">
          </jb-btn>
        </div>

        <div class="d-flex flex-column">
          <ul>
            <li *ngFor="let attendee of attendees;">
              {{attendee.email || attendee}}
            </li>
          </ul>
        </div>

      </div>
    </div>
    <div class="col-4 code-box">
      <pre>{{instanceEmail}}</pre>
    </div>
    <div class="col-4 code-box">
      <pre>{{mapUnmapExampleUpdate({ username: 'user.username', email: 'user.email'})}}</pre>
    </div>
  </div>
</div>
<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The encapsulated styles of the button use a default color. However, we may want to apply different colors
      externally (depending on the theme)
      <br/>
      To provide a color restyiling based on a SCSS theme you can apply the following rules on a css global level :
    </p>
    <pre>{{ cssReset }}</pre>
  </div>
</div>

